<script>
	// From Lucide
	import { ArrowUp } from 'lucide-svelte';

	export let iconClass = '';
</script>

<ArrowUp class={iconClass} />
